import axios from './axios';

export const fetchAllArtists = async () => {
    try {
        const response = await axios.get('/artists');
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};

export const fetchArtistById = async (artistID) => {
    try {
        const response = await axios.get(`/artists/${artistID}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};
